module.exports = __webpack_public_path__ + "static/media/eye.a8300c4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Exchange/scenes/Success/img/eye.svg
// module id = 134
// module chunks = 0